// extracted by mini-css-extract-plugin
export var carousel = "LogoCarousel-module--carousel--3c010";
export var image = "LogoCarousel-module--image--b3295";
export var overlay = "LogoCarousel-module--overlay--3d218";
export var scroll8 = "LogoCarousel-module--scroll8--ed39b";
export var scroll9 = "LogoCarousel-module--scroll9--4814a";
export var slide = "LogoCarousel-module--slide--f73ab";
export var slideTrack = "LogoCarousel-module--slide-track--07ee1";
export var slider = "LogoCarousel-module--slider--79e8d";
export var wide = "LogoCarousel-module--wide--e8751";